<template>
  <div id="app">
    <router-view/>
    <login-confirm v-if="$userInfo.loginTip"></login-confirm>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  html, body {
    font-size: 14px;
    color: #111;
    min-width: 1200px;
  }

  li {
    list-style: none;
  }

  a {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    vertical-align: baseline;
    color: inherit;
  }

  a:link,
  a:hover,
  a:active,
  a:visited {
    text-decoration: none;
    color: inherit;
  }

  img {
    border: 0 none;
  }

  body {
    /*transform: scale(0.8);*/
    /*transform-origin: center top;*/
  }

  .clearfix {
    zoom: 1;
  }

  .clearfix:after {
    content: ".";
    width: 0;
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue